import { pick, toNumber } from "@components/health/clients/health-clients-utils";

export const VID_PLAN_OPTIONS = [
  { value: 0, label: "Не планировать" },
  { value: 1, label: "Каждый день" },
  { value: 2, label: "Через день" },
  { value: 7, label: "Раз в неделю" },
  { value: 100, label: "По времени" },
  { value: 12, label: "Через день (сквозное)" }
];

export const VID_PLAN_LABELS = Object.fromEntries(VID_PLAN_OPTIONS.map((o) => [o.value, o.label]));

/** Как Delphi GetUserLaw: отсутствующий бит = разрешено. */
export const getLawFlag = (law, index) => {
  if (!law || law.length <= index) return 1;
  const n = Number(law[index]);
  return Number.isFinite(n) ? n : 1;
};

export const normalizeZag = (row) => ({
  idShb: toNumber(pick(row, "idShb", "IdShb")),
  name: pick(row, "name", "Name") ?? ""
});

export const normalizeCnt = (row) => ({
  idShb: toNumber(pick(row, "idShb", "IdShb")),
  idStr: toNumber(pick(row, "idStr", "IdStr")),
  idUsl: toNumber(pick(row, "idUsl", "IdUsl")),
  tovName: pick(row, "tovName", "TovName") ?? "",
  cnt: toNumber(pick(row, "cnt", "Cnt")),
  vidPlan: toNumber(pick(row, "vidPlan", "VidPlan")),
  isPlat: toNumber(pick(row, "isPlat", "IsPlat")),
  params: pick(row, "params", "Params", "paramsText", "ParamsText") ?? ""
});

/** Delphi TStringList: name=value по строкам. */
export const parseParamsText = (text) => {
  const raw = String(text || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  if (!raw.trim()) return [];
  return raw
    .split("\n")
    .map((line) => line.trimEnd())
    .filter((line) => line.trim() !== "")
    .map((line, index) => {
      const eq = line.indexOf("=");
      if (eq < 0) return { key: `p-${index}`, name: line, value: "" };
      return {
        key: `p-${index}`,
        name: line.slice(0, eq),
        value: line.slice(eq + 1)
      };
    });
};

export const serializeParamsRows = (rows) =>
  (rows || [])
    .filter((r) => String(r.name || "").trim() !== "")
    .map((r) => `${String(r.name).trim()}=${r.value ?? ""}`)
    .join("\n");
